import React, { useState } from 'react';
import css from './EditCheckbox.module.css';

export default function EditCheckbox(props) {

  const { isChecked, setIsChecked } = props;

  const handleOnChange = () => {
    setIsChecked(!isChecked); 
  };

  return (
    <div>
      <h3>Est-il possible de louer votre place plus de 2 mois d’affilé ?</h3>
      <form className={css.form}>
        <input
          type="checkbox"
          className={css.input}
          checked={isChecked}
          onChange={handleOnChange}
        />
        <label className={css.label}>Oui</label>
      </form>
      <form className={css.form}>
        <input
          type="checkbox"
          className={css.input}
          checked={!isChecked}
          onChange={handleOnChange}
        />
        <label className={css.label}>Non</label>
      </form>

    </div>
  );
}
